@if (visibleItems; as items) {
  <div>
    <app-pagination #pagination [items]="items">
      @for (overlander of pagination.getItemsOnPage(); track overlander; let index = $index) {
        <!-- render terminal -->
        @if (showTerminal && overlander.terminal && (index === 0
          || overlander.terminal?.terminalCode !== items[index - 1].terminal?.terminalCode)) {
          <div class="mt-3 row g-0 align-items-center">
            @if (!readonly) {
              <div class="col-auto me-2 invisible">
                <div class="form-check form-check-inline m-0" style="height: 2.5rem">
                  <input class="form-check-input m-0" type="checkbox"></div>
              </div>
            }
            <div class="col py-1 ps-3 border border-white" style="border-width: 2px!important;">
              <span class="fa fa-fw fa-map-marker-alt text-portbase-blue pe-2 me-2"></span>
              <span class="ms-1 fw-bold text-dark">{{ utils.terminalFormatter(overlander.terminal) }}</span>
            </div>
          </div>
        }
        <div class="row g-0">
          @if (!readonly) {
            <div class="col-auto me-2">
              <div class="form-check form-check-inline m-0 always-enabled" style="height: 2rem">
                <input [(ngModel)]="overlander['selected']" class="always-enabled form-check-input m-0" type="checkbox">
              </div>
            </div>
          }
          <div class="col">
            <app-collapse #overlanderCollapse [collapse]="overlanderTemplate" [animateOnLoad]="true">
              <div class="row g-0 py-1 px-3 align-items-center text-dark">
                <div class="col">
                  <span class="fa fa-fw fa-cube pe-2 me-2"></span>
                  <span class="d-inline-block align-top text-truncate">{{ overlander.number }}</span>
                </div>
                <div class="col-auto me-3 d-none d-md-block text-dark">
                  <app-cargo-summary [overlander]="overlander"
                                     [keepTooltipOpen]="overlanderCollapse.showing"></app-cargo-summary>
                </div>
              </div>
            </app-collapse>
          </div>
        </div>
        <ng-template #overlanderTemplate>
          <div class="collapse">
            <div class="mx-3 pt-3 fieldset disabled">
              <app-import-container [container]="$any(overlander)"></app-import-container>
            </div>
          </div>
        </ng-template>
      }
      @if (!readonly && items.length > 1) {
        <div class="row g-0 text-secondary">
          <label class="py-2">
            <input [checked]="selectedItems.length === items.length && items.length > 0"
                   (click)="toggleSelectAll()" class="always-enabled" type="checkbox">
            <span class="ms-2">Select all</span>
          </label>
        </div>
      }
    </app-pagination>
  </div>
}

@if (hiddenItems.length; as hiddenCount) {
  <div class="text-center text-muted" style="padding: 20px 0">
    Hiding {{ hiddenCount }} filtered overlander{{ hiddenCount == 1 ? '' : 's' }}
    <button type="button" class="btn btn-outline-info btn-sm ms-2" (click)="showAll()">Show all</button>
  </div>
}

@if (selectedItems.length > 0) {
  <div class="fixed-bottom row g-0 justify-content-center bg-white py-3 border-top">
    <div class="col-auto mx-1">
      <button class="btn btn-outline-danger" style="min-width: 10rem" type="button"
              (click)="refuseSelectedOverlanders()">Refuse containers
      </button>
    </div>
    <div class="col-auto mx-1">
      @if (manifest) {
        <button class="btn btn-outline-info" style="min-width: 10rem"
                type="button" (click)="addSelectedToManifest(manifest.portOfLoading)">Add to manifest
        </button>
      } @else {
        <div class="dropdown">
          <button class="btn btn-outline-info dropdown-toggle" style="min-width: 10rem" type="button"
                  data-bs-toggle="dropdown">Add to manifest
            <span class="caret"></span></button>
          <ul class="dropdown-menu dropdown-menu-start">
            @for (previousPort of utils.getPreviousPorts(); track previousPort) {
              <li class="dropdown-item"
                  (click)="addSelectedToManifest(previousPort)">
                From: {{ previousPort.name | titlecase }}
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
}
